module.exports = __webpack_public_path__ + "img/playBtn.61e78526.png";